import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Template } from '../../models/template.model';
import { Cabecalho } from '../../models/cabecalho.model';
import { RequestsService } from '../../services/requests.service';
import { SideMenuLiveViewComponent } from '../../components/side-menu-live-view/side-menu-live-view.component';
import { SideMenuLiveViewComponentTeste } from '../../components/side-menu/side-menu.component';
import { JsonViewerComponent } from '../../_helpers/json-viewer/json-viewer.component';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'editor-cabecalho',
  templateUrl: './editor-cabecalho.component.html', 
  styleUrls: ['./editor-cabecalho.component.scss']
})
export class EditorCabecalhoComponent implements OnInit {

  @ViewChild('menuLateral', { static: true }) public menuLateral: SideMenuLiveViewComponent
  @ViewChild('modalDatafield', { static: true }) private modalDatafield: JsonViewerComponent
  public cabecalhoSelecionado: Cabecalho;
  public report: Cabecalho = new Cabecalho();
  sidenavOpened = false;
  editorOptions = {theme: 'vs-dark', language: 'html'};
    
  constructor(private route: ActivatedRoute, private requestService: RequestsService, private toastService: ToastService) {

  }

  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      this.route.params.subscribe(pathParam => {
        let paramsString = JSON.stringify(params);

        this.requestService.getCabecalho(pathParam['idReport']).subscribe(result => {
          this.report = result;
          this.menuLateral.iniciar(this.report, true);
        });
      });
    });

  }

  openModalDatafield() {
    let datafield = this.menuLateral.datasets.find(x => x.idDataset == this.report.idDataset);
    this.modalDatafield.abrir("Datafields (Mapeamento) dos Campos de Consulta", datafield.dataFieldsJson, true);
  }

  openModalCommand() {
    this.toastService.showDangerWithHeader("Erro ao salvar as alterações!","")
    // let datafield = this.menuLateral.datasets.find(x => x.idDataset == this.report.idDataset);
    // this.modalDatafield.abrir("Comando Sql Dataset Com Filtros", datafield.comando, false);
  }


  updateTemplate() {
    this.requestService.updateCabecalho(this.report).subscribe(x => {
      this.toastService.showSuccess("Alterações salvas com sucesso!");
    }
      , error => {
        this.toastService.showDanger("Erro ao salvar as alterações!" + error)
      });
  }
}
